import { Modal, Breadcrumb, Descriptions } from "antd";
import { HomeOutlined, FolderOutlined } from "@ant-design/icons";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "../../../store/store";
import {
  resetPhaseInDetailModalSlice,
  updatePhaseInDetailModalSlice,
} from "../../../store/slices/projectManagement/phase-view/PhaseInDetailView";
import dayjs from "dayjs";
import { Popconfirm } from "antd/lib";
import { Icon } from "../../../components/Component";
import { resetActivityInDetailModalSlice } from "../../../store/slices/projectManagement/activity-view/ActivityInDetailView";
import ActivityInDetailView from "./ActivityInDetailsView";
import { updateRootPageRenderState } from "../../../store/slices/projectManagement/task-list-view/TaskListDetailModalSlice";
import { useWbsName } from "../shared/useWbsCodes";
import { useEffect, useState } from "react";

const ActivityInDetailModal = () => {
  const dispatch = useDispatch();
  const wbsName = useWbsName();
  const [screenSize, setScreenSize] = useState(0);

  // Function to handle screen size changes
  const viewChange = () => {
    setScreenSize(window.innerWidth);
  };

  const { data: ActivityInDetailModal } = useSelector(
    (state: RootState) => state.ActivityInDetailModal
  );
  const { data: RootPageRenderState } = useSelector(
    (state: RootState) => state.RootPageRenderState
  );
  const {
    id, // activityId
    open,
    activityName,
    activeTab,
    onClose,
    extra,
    projectResponse,
    phaseResponse,
  } = ActivityInDetailModal;

  const { name: projectName } = projectResponse;
  const { name: phaseName } = phaseResponse;

  // Handle breadcrumb click
  const handleProjectBreadcrumbClick = () => {
    dispatch(resetActivityInDetailModalSlice());
    dispatch(resetPhaseInDetailModalSlice());
    dispatch(updateRootPageRenderState(!RootPageRenderState));
  };

  const handlePhaseBreadcrumbClick = () => {
    dispatch(resetActivityInDetailModalSlice());
    if (onClose == "openPhaseModal") {
      dispatch(
        updatePhaseInDetailModalSlice({
          open: true,
        })
      );
    } else {
      console.log("No Phase Modal Data to open");
    }
  };

  // Handle screen size changes
  useEffect(() => {
    viewChange();
    window.addEventListener("load", viewChange);
    window.addEventListener("resize", viewChange);
    return () => {
      window.removeEventListener("resize", viewChange);
      window.removeEventListener("load", viewChange);
    };
  }, []);

  return (
    <Modal
      className="detail-view-modal"
      maskClosable={false}
      title={
        <div className="d-flex justify-content-start align-items-center">
          <Breadcrumb
            items={[
              {
                title: <HomeOutlined />,
              },
              {
                title: (
                  <span
                    className="parent-nav"
                    onClick={handleProjectBreadcrumbClick}
                  >
                    <FolderOutlined style={{ marginRight: 4 }} />
                    {projectName}
                  </span>
                ),
              },
              {
                title: (
                  <span
                    className={onClose == "openPhaseModal" ? `parent-nav` : ""}
                    onClick={handlePhaseBreadcrumbClick}
                  >
                    {wbsName(phaseName)}
                  </span>
                ),
              },
              {
                title: wbsName(activityName),
              },
            ]}
          />
          <Popconfirm
            placement="right"
            title={<></>}
            icon={<></>}
            showCancel={false}
            trigger="hover"
            okButtonProps={{
              style: {
                display: "none",
              },
            }}
            description={
              <div className="d-flex flex-column">
                <Descriptions
                  title=""
                  bordered
                  column={1}
                  size="small"
                  className="custom-description-title"
                >
                  <Descriptions.Item label="Status">
                    {extra?.status}
                  </Descriptions.Item>
                  <Descriptions.Item label="Start Date">
                    {dayjs(extra?.startDate)?.format("DD-MMM-YYYY")}
                  </Descriptions.Item>
                  <Descriptions.Item label="End Date">
                    {dayjs(extra?.endDate)?.format("DD-MMM-YYYY")}
                  </Descriptions.Item>
                  <Descriptions.Item label="Owner">
                    {extra?.ownerName || "--"}
                  </Descriptions.Item>
                  <Descriptions.Item label="Created At">
                    {dayjs(extra?.createdAt)?.format("DD-MMM-YYYY")}
                  </Descriptions.Item>
                  <Descriptions.Item label="Created By">
                    {extra?.createdByUserName || "--"}
                  </Descriptions.Item>
                </Descriptions>
              </div>
            }
          >
            <Icon
              name="info"
              className="ms-1"
              style={{
                cursor: "pointer",
              }}
            />
          </Popconfirm>
        </div>
      }
      style={{ top: 8 }}
      width={"99%"}
      animation={false}
      open={open}
      footer={null}
      onCancel={() => {
        dispatch(resetActivityInDetailModalSlice());
        switch (onClose) {
          case "openPhaseModal":
            dispatch(updatePhaseInDetailModalSlice({ open: true }));
            break;
          default:
            dispatch(updateRootPageRenderState(!RootPageRenderState));
            dispatch(resetPhaseInDetailModalSlice());
        }
      }}
    >
      <ActivityInDetailView id={id} activeTab={activeTab} />
    </Modal>
  );
};

export default ActivityInDetailModal;
